<template>
  <header class="site-header" v-html="content"></header>
</template>

<script>
import { mapGetters } from "vuex";
import config from "@/config.js";
import { getAuthRedirect } from "@/utils/authRedirect";
import { renderHeaderContent } from "@/content/chrome";

export default {
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    content() {
      return renderHeaderContent({ docsUrl: config.DocsUrl, isLoggedIn: this.isLoggedIn, authRedirect: getAuthRedirect(this.$route.query) });
    },
  },
};
</script>
